import { render, staticRenderFns } from "./account-payable.vue?vue&type=template&id=705b7ad0"
import script from "./account-payable.vue?vue&type=script&lang=js"
export * from "./account-payable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports